import styled, { css } from 'styled-components';

import { defaultThemeProp } from '@pega/cosmos-react-core';

const FeedButton = styled.button<{ emphasized?: boolean }>(props => {
  const { emphasized, theme } = props;

  return css`
    color: ${emphasized ? theme.base.palette.interactive : theme.base.palette['foreground-color']};

    span {
      margin-inline-start: ${theme.base.spacing};
    }
  `;
});

FeedButton.defaultProps = defaultThemeProp;

export default FeedButton;
